var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.FilterChip, {
        attrs: {
          "is-active": Boolean(_setup.selectedCity?.name),
          name: _setup.selectedCity?.name || "Выбрать город",
        },
        on: {
          click: function ($event) {
            _setup.isVisibleModal = true
          },
          "click:close": _setup.onReset,
        },
      }),
      _vm._v(" "),
      _c(_setup.CoreSelectionDrawer, {
        attrs: {
          "has-search": "",
          "has-footer": "",
          title: "Выбрать город",
          placeholder: "Найти",
          value: _setup.isVisibleModal,
          items: _setup.cities,
          "selected-item": _setup.selectedCity,
          loading: _setup.loading,
          error: _setup.error,
        },
        on: {
          input: function ($event) {
            _setup.isVisibleModal = false
          },
          "click-item": _setup.handleClickCity,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }